import api from "lib/axios";
import { ApiEnvelope, PaginatedResult, unwrapData, unwrapList } from "./apiTypes";

type Query = Record<string, unknown> | undefined;
type Payload = Record<string, unknown>;

function createEntityService(basePath: string) {
  return {
    async list(params?: Query) {
      const response = await api.get<ApiEnvelope<PaginatedResult<any>>>(basePath, {
        params,
        meta: { toastSuccess: false },
      });
      return unwrapList(response.data);
    },
    async show(id: number | string) {
      const response = await api.get<ApiEnvelope<{ data: any }>>(`${basePath}/${id}`, {
        meta: { toastSuccess: false },
      });
      return unwrapData(response.data);
    },
    async create(data: Payload) {
      const response = await api.post<ApiEnvelope<{ data: any }>>(basePath, data);
      return unwrapData(response.data);
    },
    async update(id: number | string, data: Payload) {
      const response = await api.put<ApiEnvelope<{ data: any }>>(`${basePath}/${id}`, data);
      return unwrapData(response.data);
    },
    async delete(id: number | string) {
      const response = await api.delete(`${basePath}/${id}`);
      return response.data;
    },
    async block(id: number | string) {
      const response = await api.post(`${basePath}/${id}/block`);
      return response.data;
    },
    async unblock(id: number | string) {
      const response = await api.post(`${basePath}/${id}/unblock`);
      return response.data;
    },
  };
}

export const studentService = createEntityService("/mcp/students");
export const instructorService = createEntityService("/mcp/instructors");
export const subjectService = createEntityService("/mcp/subjects");

